import { PagerService } from './../../services/pager.service';
import { NotificationService } from './../../services/notification.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { ClassBaseService } from './../../services/class-base.service';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit, OnChanges {
  @Input() dynamicStudentId: any;
  @Input() studentPartnerId: any;
  articles = [];
  currentPage = 1; // variable to store current page
  totalItems = 0; // variable to store total items
  maxSize = 50; // variable to store max size
  pageShow = false; // variable to check if pagination to be shown or not
  categories = [];
  categoryId = '0';
  searchFilter = '';
  studentUserId: any;
  changeValueFlag: boolean;
  userRole: string;
  pager: any = {};
  pagedItems: any[];
  loader = false;

  constructor(
    private _classBaseService: ClassBaseService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private notificationService: NotificationService,
    private draggableModalService: DraggableModalService,
    private pagerService: PagerService,
    private route: Router
  ) { }

  ngOnInit() {
    this.studentUserId = this._commonAuthService.getLoginData().userId;
    this.userRole = this._commonAuthService.getModule();
    if (!this.changeValueFlag) {
      this.getCategoryData();
    }
  }

  ngOnChanges() {
    if (this.dynamicStudentId && this.studentPartnerId) {
      this.changeValueFlag = true;
      this.getCategoryData();
    } else {
      this.changeValueFlag = false;
    }
  }

  getCategoryData() {
    this._classBaseService.getStudentProgessCategories(this.studentPartnerId)
      .subscribe(
        (data: any) => {
          this.categories = data;
          this.getArticleData();
        }, () => {
          this.notificationService.show('error', 'Error while fetching category data');
        });
  }
  /**
   *@ngdoc method
   *@name getArticleData
   *@methodOf article.component
   *@description
   * - This is a method, which is used to get article data by api call
  */
  getArticleData() {
    if (!['coach', 'parent'].includes(this.userRole)) {
      this.loader = true;
    }
    const inputJson = {
      userId: this.studentUserId.toString(),
      studentUserId: this.dynamicStudentId || this.studentUserId.toString(),
      categoryClassID: this.categoryId,
      page: this.currentPage,
      pageSize: this.maxSize,
      partnerId: this.studentPartnerId
    };
    this._commonRequestResponseService.postWithHeader('Shared/articles/', inputJson, ['partnerId'])
      .subscribe(
        (articleJson: any) => {
          this.loader = false;
          this.articles = articleJson.items;
          this.pageShow = true;
          this.totalItems = articleJson.totalItems;
          this.setPage(1);
          this.filterArticles();
        },
        () => {
          this.articles = [];
          this.loader = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  pageChanged(event: any) {
    this.getArticleData();
  }
  setPage(pageNo: number) {
    this.pager = this.articles ? this.pagerService.getPager(this.articles.length, pageNo, this.maxSize) : {};
    this.pagedItems = this.articles ? this.articles.slice(this.pager.startIndex, this.pager.endIndex + 1) : [];
  }
  filterArticles() {
    if (this.articles) {
      this.articles.forEach((article: any) => {
        article.isHidden = article.title.toLowerCase().includes(this.searchFilter.toLowerCase());
      });
    }
  }
  onArticleClick(item) {
    if (this.userRole && this.userRole.trim().toLowerCase() === 'student' && item.contentName === 'Student Success') {
      this.readArticle(item);
    }
    const baseId = 'modal-coachinghub-article';

    this.draggableModalService.show({
      baseId,
      id: `${baseId}-${item.articleId}-${item.articleCategoryClassID}-${item.articleContentClassID}`,
      trayTitle: item.title,
      initialState: {
        title: item.title,
        content: item.summary
      }
    });

    if (this.userRole && this.userRole.trim().toLowerCase() === 'student') {
      const inputJson = {
        userId: this.studentUserId.toString(),
        contentId: item.articleId,
        partnerId: this.studentPartnerId,
        Completed: 1
      };

      this._commonRequestResponseService.postWithStaticHeaderData('admin/content/autocomplete', inputJson)
        .subscribe(
          () => {
            // ???
          },
          () => {
            this.notificationService.show('error', 'Error while calling service');
          });
    }
  }

  readArticle(article) {
    const inputJson = {
      studentUserId: this.studentUserId,
      articleCategoryClassID: article.articleCategoryClassID,
      articleContentClassID: article.articleContentClassID,
    };

    this._commonRequestResponseService.postWithHeader('shared/readarticle', inputJson)
      .subscribe(() => {
        // ???
      });
  }
}
